// Copyright (c) 2018 Deere & Company

import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import Dropzone from 'react-dropzone';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {showLoadingIndicator} from '../../../shared/state/busy-counter';

const FileUploadPanel = props =>
    (
        <section>
            <BusyCounterLoadingIndicator busyCounter={props.busyCounter}/>
            <header>
                <h2 className="page-header">
                    {props.uploadLabel}
                </h2>
            </header>
            <div className="section-with-aside">
                <main>
                    <div className="file-upload-panel">
                        <div className="upload-area">
                            <Dropzone
                                class="dropzone-area"
                                accept=".csv"
                                multiple={false}
                                onDropAccepted={props.handleFileDrop.bind(props)}
                                onDropRejected={props.handleRejectedFiles}
                            >
                                {() => (
                                    <div className="dropzone">
                                        {props.fileName === undefined &&
                                            <FormattedMessage
                                                id="Drag a file here to upload it, or click to browse. Only CSV files are allowed"/>
                                        }
                                        {props.fileName !== undefined &&
                                            (
                                                <div className="upload-file-icon">
                                                    <i className="fa fa-file"/>
                                                    <span>{props.fileName}</span>
                                                    <span className="file-upload-suggestion">Click Submit to Upload File. Click Cancel to remove file.</span>
                                                </div>
                                            )}
                                    </div>
                                )}
                            </Dropzone>
                        </div>

                        {props.fileName !== undefined && (
                            <div>
                                <div className="btn-area">
                                    <button className="close-button" type="button"
                                            onClick={props.handleCancleClick}>Cancel
                                    </button>
                                    <button className="primary-button" type="button"
                                            onClick={props.handleSubmitClick}>Submit
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </section>
    )
;
// const handleCheckboxChange = e => {
//     console.log("(e.target.checked)", e);
//
// };
FileUploadPanel.displayName = 'FileUploadPanel';
FileUploadPanel.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    uploadLabel: PropTypes.string.isRequired,
    handleFileDrop: PropTypes.func.isRequired,
    handleRejectedFiles: PropTypes.func.isRequired,
    handleSubmitClick: PropTypes.func.isRequired,
    handleCancleClick: PropTypes.func.isRequired,
    fileName: PropTypes.string,
    refineWorklist: PropTypes.bool,
    isRefineWorklist: PropTypes.bool,
    handleCheckBoxClick: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});
const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
});
export default connect(mapStateToProps, mapDispatchToProps)(FileUploadPanel);
